@if (!isHidden() || hisBaseGlobalsService.dataDictionaryEditMode()) {
  <div class="plamRow layoutBlock" [tabindex]="tabindex" (mouseenter)="onMouseEnter($event)">
    @if (tabindex === 0 && hasBackendErrors && !isHidden() && getFirstErrorMessage() !== null) {
      <div class="unsichtbar">{{'common.error' | hisUi}}: {{getFirstErrorMessage()}}</div>
    }
    @if (!isCheckboxRadio) {
      <div class="plamLabelContainer" [ngClass]="showLabelTop ? 'labelTopLayout' : ' '">
        @if (isRequired()) {
          @if (!renderLabelAsDiv) {
            <label class="plamLabel formLabel" for="{{isTranslatable() && translationLanguage ? contentId + '_readonly' : contentId }}">
              {{requiredIndicator}} {{label ? label : (getLabeltext() | hisUi)}}
              @if (hasBackendErrors && !isHidden() && getFirstErrorMessage() !== null) {
                <div class="unsichtbar">{{'common.error' | hisUi}}: {{getFirstErrorMessage()}}</div>
              }
              @if (hasErrorMessageBeforeSave()) {
                <div class="unsichtbar">{{'common.error' | hisUi}}: {{getErrorMessageBeforeSave()}}</div>
              }
            </label>
          } @else {
            <div class="plamLabel formLabel ngLabelAsDiv">
              {{requiredIndicator}} {{label ? label : (getLabeltext() | hisUi)}}
              @if (hasBackendErrors && !isHidden() && getFirstErrorMessage() !== null) {
                <div class="unsichtbar">{{'common.error' | hisUi}}: {{getFirstErrorMessage()}}</div>
              }
              @if (hasErrorMessageBeforeSave()) {
                <div class="unsichtbar">{{'common.error' | hisUi}}: {{getErrorMessageBeforeSave()}}</div>
              }
            </div>
          }
        } @else {
          @if (!renderLabelAsDiv) {
            <label class="plamLabel formLabel" for="{{isTranslatable() && translationLanguage ? contentId + '_readonly' : contentId }}">
              {{label ? label : (getLabeltext() | hisUi)}}
              @if (hasErrorMessageBeforeSave()) {
                <div class="unsichtbar">{{'common.error' | hisUi}}: {{getErrorMessageBeforeSave()}}</div>
              }
            </label>
          } @else {
            <div class="plamLabel formLabel ngLabelAsDiv">
              {{label ? label : (getLabeltext() | hisUi)}}
              @if (hasErrorMessageBeforeSave()) {
                <div class="unsichtbar">{{'common.error' | hisUi}}: {{getErrorMessageBeforeSave()}}</div>
              }
            </div>
          }
        }
      </div>
      <div class="plamContent">
        @if (isTranslatable() && translationLanguage) {
          <!-- at this point we want to render a input/textarea/his-editor that looks the same as the original content -->
          @if (contentRef.nativeElement.tagName === 'INPUT') {
            <input readonly class="{{this.contentRef.nativeElement.className}}" value="{{contentRef.nativeElement.defaultLanguageValue}}" id="{{contentId + '_readonly'}}" >
          }
          @if (contentRef.nativeElement.tagName === 'TEXTAREA') {
            <textarea readonly class="{{this.contentRef.nativeElement.className}}" rows="{{contentRef.nativeElement.rows}}" id="{{contentId + '_readonly'}}">{{ contentRef.nativeElement.defaultLanguageValue }}</textarea>
          }
          @if (contentRef.nativeElement.tagName === 'HIS-EDITOR') {
                <his-editor [disabled]="true" class="{{this.contentRef.nativeElement.className}}"
                            [ngModel]="contentRef.nativeElement.defaultLanguageValue" toolbar="none"
                            [showDocumentationLink]="false"id="{{contentId + '_readonly'}}">
                </his-editor>
          }
        }
        @if (!isTranslatable() || !translationLanguage) {
          <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        }
      </div>
      <!-- The following contains the translation field #221537 -->
      @if (isTranslatable() && translationLanguage) {
        <div class="plamLabelContainer" [ngClass]="showLabelTop ? 'labelTopLayout' : ' '">
          <label class="plamLabel formLabel" for="{{contentId}}">
            <span hisImage="COMMENT_{{translationLanguage.uniquename}}" alt=" "></span>
            {{getTranslationLabel(translationLanguage.uniquename) | hisUi: (label ? label : (getLabeltext() | hisUi))}}
			 </label>
        </div>
        <div class="plamContent">
          <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        </div>
      }
    }
    @if (isCheckboxRadioAfterLable && isCheckboxRadio) {
      <div class="plamLabelContainer" [ngClass]="showLabelTop ? 'labelTopLayout' : ' '">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        <label class="plamLabel formLabel" for="{{contentId}}">
          @if (isRequired()) {
            <span>*</span>
          }
          {{label ? label : (getLabeltext() | hisUi)}}
        </label>
      </div>
      <div class="plamContent">
      </div>
    }
    @if (!isCheckboxRadioAfterLable && isCheckboxRadio) {
      <div class="plamLabelContainer plamLabelCheckboxBefore" [ngClass]="showLabelTop ? 'labelTopLayout' : ' '">
      </div>
      <div class="plamContent plamContent-checkboxBefore">
        <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
        <label class="plamLabel formLabel" for="{{contentId}}">
          @if (isRequired()) {
            <span>*</span>
          }
          {{label ? label : (getLabeltext() | hisUi)}}
        </label>
      </div>
    }
    <ng-template #contentTpl><ng-content></ng-content></ng-template>
    <div class="plamButtonContainer">
      <div style="white-space: nowrap">
        <!-- Custom buttons may be useful for widgets representing objects, -->
        <!-- like an edit button when we selected a journal. -->
        <ng-content select="[customPlamButtons]"></ng-content>
        @if (debugAvailable) {
          <button
            hisImage="debug"
            type="button"
            class="plamButton icon"
            [title]="'Debuginfos'"
            (click)="toggleShowDebug()">
          </button>
        }
        @if (getHelptext()) {
          <button
            hisImage="information"
            type="button"
            class="plamButton icon"
            [title]="('common.components.info' | hisUi) + ' ' + (label ? label : (getLabeltext() | hisUi))"
            [attr.aria-label]="('common.components.info' | hisUi) + ' ' + (label ? label : (getLabeltext() | hisUi))"
            (click)="toggleShowHelptext()">
          </button>
        }
      </div>
    </div>
    @if (shouldDisplayErrors() && hasErrors() && !hasErrorMessageBeforeSave() && !getBackendError()) {
    <div class="plamLabelContainer"></div>
    <div class="plamRow plamWarningtextContainer ui-g">
        <div class="plamWarningtextSpacer ui-g-12 ui-md-12 ui-lg-11 ui-xl-4"></div>
        <div class="plamWarningtext ui-g-12 ui-md-12 ui-lg-11 ui-xl-7" role="alert">{{getFirstErrorMessage()}}</div>
    </div>
    }
    @if (hasBackendErrors && getFirstErrorMessage() !== null) {
    <div class="plamLabelContainer"></div>
    <div class="plamRow ui-g">
        <div class="plamWarningtextSpacer ui-g-12 ui-md-12 ui-lg-11 ui-xl-4"></div>
        <div id="{{contentId}}_errortext" class="errortext ui-g-12 ui-md-12 ui-lg-11 ui-xl-7">{{'common.error' | hisUi}}: {{getFirstErrorMessage()}}</div>
    </div>
    }
    @if (getBackendError()) {
        <div class="plamLabelContainer"></div>
    <div class="plamRow ui-g">
        <div class="plamHelptextSpacer ui-g-12 ui-md-12 ui-lg-11 ui-xl-4"></div>
        <div class="errortext ui-g-12 ui-md-12 ui-lg-11 ui-xl-7" [innerHTML]="('common.error'| hisUi) + ': ' + getBackendError()"></div>
    </div>
    }
    @if (hasErrorMessageBeforeSave()) {
        <div class="plamLabelContainer"></div>
    <div class="plamRow ui-g">
        <div class="plamWarningtextSpacer ui-g-12 ui-md-12 ui-lg-11 ui-xl-4"></div>
        <div id="{{contentId}}_errormessage" class="errortext ui-g-12 ui-md-12 ui-lg-11 ui-xl-7">{{'common.error' | hisUi}}: {{getErrorMessageBeforeSave()}}</div>
    </div>
    }
        <div [ngClass]="{'visibilityOnlyForScreenreader': !displayHelptext || isHidden()}" class="plamRow plamHelptextContainer ui-g">
            <div class="plamHelptextSpacer ui-g-12 ui-md-12 ui-lg-11 ui-xl-4"></div>
            <div id="{{contentId}}_helptext" class="plamHelptext ui-g-12 ui-md-12 ui-lg-11 ui-xl-7" [innerHTML]="getHelptext()"></div>
        </div>
        <his-dd-popup [ddIdentifier]="getDdIdentifier()" [ddContexts]="getDdContexts()" [dataSource]="getDataSource()"></his-dd-popup>
    </div>
    @if (showDebug) {
    <div class="plamRow">
        <pre>Value: {{getModelValue() | json}}</pre>
        <pre>Errors: {{getErrors() | json}}</pre>
        <pre>ValidationMessage: {{getValidationMessage()}}</pre>
    </div>
    }
}